<template>
  <div class="container-fluid mt-5">
    <div>
      <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("ESTABLISHMENT_INTERNAL_ORDERS.ESTABLISHMENT_INTERNAL_ORDERS_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <help-button context="internal-orders" />
              <base-button
                type="secondary"
                icon
                size="sm"
                class="mr-2"
                @click="goToDailyPreparations()"
                v-if="
                  $currentUserCan($permissions.PERM_VIEW_ANY_ESTABLISHMENT_INTERNAL_ORDERS) &&
                  $currentUserManagesProductionCafeteria()
                "
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-utensils"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("ESTABLISHMENT_INTERNAL_ORDERS.PRODUCTIONS_TO_MAKE") }}
                </span>
              </base-button>

              <base-button
                type="primary"
                icon
                size="sm"
                @click="addOrder()"
                v-if="$currentUserCan($permissions.PERM_CREATE_ESTABLISHMENT_INTERNAL_ORDERS)"
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("COMMON.ADD") }}
                </span>
              </base-button>

              <notification-subscription
                v-if="$currentUserCan($permissions.PERM_VIEW_ESTABLISHMENT_INTERNAL_ORDERS)"
                :objectType="'establishment-internal-orders'"
                :events="{
                  CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>

        <establishment-internal-order-list-table
          :filterEstablishment="$route.query.establishment || null"
          :hideAddButton="true"
        />
      </card>
    </div>
  </div>
</template>

<script>
import EstablishmentInternalOrderListTable from "./partials/EstablishmentInternalOrderListTable.vue";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import { Button } from "element-ui";

export default {
  name: "ListEstablishmentInternalOrderPage",
  components: {
    EstablishmentInternalOrderListTable,
    NotificationSubscription,
    [Button.name]: Button,
  },

  methods: {
    addOrder() {
      this.$router.push({ name: "Add EstablishmentInternalOrder" });
    },
    goToDailyPreparations() {
      this.$router.push({ name: "Internal Preparations" });
    },
  },
};
</script>
